// FIXME: update to use a const object instead of a typescript enum
// eslint-disable-next-line @box/platform/no-enums
export enum ProviderStatusType {
  Pending = 0,
  Created = 1,
  Billable = 2,
}
